<template>
  <!--about body-->
  <div class="about_body">
    <div class="banner-top"><img src="@/images/1643429033947118.jpg"></div>
    <div class="sevenpage">
      <div class="main">
        <div class="ntitle hidden-xs" style="margin-top:30px;margin-bottom:30px;">
          <h5>
            <img src="@/images/tb1.png" class="img-responsive"style="float:left;padding-top: 8px;"> 当前位置：
            <router-link to="/home" > 首页 </router-link> >> <router-link to="/about">
            公司简介 </router-link>
          </h5>
        </div>
        <div>
          <div class="product-fl text-center hidden-xs" style="margin-bottom: 40px;margin-right: 40px;">
            <div class="pro-title"><span>ABOUT US</span>
              <p>公司简介</p>
            </div>
            <div class="treebox">
              <ul class="menu">
              </ul>
            </div>

            <Contract />

          </div>
          <div class="nrbf">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上海欧淮贸易有限公司于2018年成立，公司位于上海市青浦区，主要销售欧洲进口工业备件，进口商品涉及气动、液压、流体、工业控制、机械传动等众多品类，广泛用于交通运输、机械机电、服装纺织、包装、水利水电、石油化工等行业。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为了更好的服务客户，上海欧淮建立自己的供应链渠道，在德国成立分公司，降低了采购和物流成本。依托良好的进货渠道、人性化的管理理念和先进的营销网络，结合自身在供销和售后方面的优势，以丰富的库存、快捷的反应和高性能及高品质的产品，为客户提供尽善尽美的服务。上海欧沁始终秉承“质量第一、诚信为本、用户至上”的宗旨，凭借价格及服务优势，与国内众多客户建立了长期友好的合作关系。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们拥有专业的销售团队，能快速响应您需求，为您提供专业和高效的交流和支持。欢迎广大新老客户来电来访洽谈业务。</p>
          </div>
        </div>
      </div>
      <div style="clear: both;"></div>
    </div>
  </div>
</template>

<script>
import Contract from './Contract.vue'
export default {
  name: 'About',
  components: {
    Contract
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ntitle h5 * {
  color: white;
  font-size: 14px;
  padding: 0 8px
}

.ntitle h5 *:hover {
  font-weight: bold
}
</style>
